/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargos_Search_Oci_PlaceholderInputs */

const en_cargos_search_oci_placeholder = /** @type {(inputs: Cargos_Search_Oci_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search OCI...`)
};

const es_cargos_search_oci_placeholder = /** @type {(inputs: Cargos_Search_Oci_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar OCI...`)
};

/**
* | output |
* | --- |
* | "Search OCI..." |
*
* @param {Cargos_Search_Oci_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_search_oci_placeholder = /** @type {((inputs?: Cargos_Search_Oci_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_Search_Oci_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_search_oci_placeholder(inputs)
	return es_cargos_search_oci_placeholder(inputs)
});